import { lazy } from "react";
import { ElementDetails } from "@/lib/types";
import { Sizes } from "./constants";
import { MergeRequestsProps } from "./types";

export const details = {
  name: "GitlabMergeRequests",
  description: "List Project Merge Requests",
  tags: ["Development"],
  category: "Gitlab",
  grid: Sizes,
  gridNames: {
    default: "Medium",
    large: "Large",
  },
  integrationsUsed: ["gitlab"],
  setup: lazy(() => import("./Setup").then(m => ({ default: m.Setup }))),
  defaultProps: {},
} as ElementDetails<MergeRequestsProps>;
